/**
 * Hunarvar – Nav Dropdown
 * Aktiviert Klick-Toggle, Keyboard-Support und Outside-Close
 * fuer Parent-Links (div role="button").
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var parents = document.querySelectorAll('.nav__link--parent');
    if (!parents.length) return;

    function closeAll(except) {
      parents.forEach(function (b) {
        if (b !== except) b.setAttribute('aria-expanded', 'false');
      });
    }

    function toggle(btn) {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll(btn);
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    parents.forEach(function (btn) {
      btn.addEventListener('click', function () { toggle(this); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(this);
        }
      });
    });

    var subParents = document.querySelectorAll('.nav__dropdown-link--parent');
    subParents.forEach(function (btn) {
      function toggleSub() {
        var open = btn.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleSub();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          toggleSub();
        }
      });
    });

    function closeAllSubs() {
      subParents.forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav__item--has-dropdown')) {
        closeAll(null);
        closeAllSubs();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll(null);
        closeAllSubs();
      }
    });
  });
})();
